/** 
 * Wrapper for server calls.
 *
 */
import C from '../C';
import ServerIO from '../base/plumbing/ServerIOBase';

export default ServerIO;

// Default to using local services on local machine, test cluster on test, and production cluster on production.
// Rather than changing this, create a file config/$hostname.js to set overrides on your machine.
/** The initial part of an API call. Allows for local to point at live for debugging */
// ServerIO.APIBASE = '';
ServerIO.AS_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}as.good-loop.com`;
ServerIO.DATALOG_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}lg.good-loop.com/data`;
ServerIO.MEDIA_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}uploads.good-loop.com`;
ServerIO.CHAT_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}chat.good-loop.com/reply`;
ServerIO.DEMO_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}demo.good-loop.com`;
ServerIO.MYLOOP_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}my.good-loop.com`;
ServerIO.MEASURE_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}measure.good-loop.com/measure`;


/** Where to look for animation templates */ // NB: local files only work if you set local juice & adrecorder too!
ServerIO.ANIM_ENDPOINT = `${C.HTTPS}://${C.SERVER_TYPE}portal.good-loop.com/_anim`; 

ServerIO.GREENCALC_ENDPOINT = ServerIO.PORTAL_ENDPOINT+"/greencalc";

// Juice and adrecorder services both run on a machine located in the Edinburgh office
ServerIO.JUICE_ENDPOINT = 'https://juice.good-loop.com:8800/';
ServerIO.ADRECORDER_ENDPOINT = 'https://adrecorder.good-loop.com:8888/record';


ServerIO.DATALOG_DATASPACE = 'gl';



/** Tell the ServerIO.upload function that this app's upload endpoint is set up to allow progress reports */
ServerIO.UPLOAD_PROGRESS_SUPPORT = true;

ServerIO.checkBase();


// override for (ad)vert
let super_geft = ServerIO.getEndpointForType;
ServerIO.getEndpointForType = (type) => {
	if (C.TYPES.isAdvert(type)) return '/vert';
	if (C.TYPES.isAdvertiser(type)) return '/vertiser';
	return super_geft(type);
};

// override for Budget
const superGUFI = ServerIO.getUrlForItem;
ServerIO.getUrlForItem = ({type, id, status}) => {
	// // Hack: budget
	// if (C.TYPES.isBudget(type)) {
	// 	let servlet = ServerIO.getEndpointForType(type);
	// 	// HACK: chop budget_ and call (ad)vert		
	// 	let url = servlet+'/'+encURI(id.substr(7))+'/budget.json';
	// 	return url;
	// }
	// use the super method
	return superGUFI({type,id,status});
};

/**
 * @returns Promise {
 * 	by_$breakdown: {String: Money}
 * 	total: {Money},
 * 	stats: {}
 * }
 */
ServerIO.getSpendData = ({q, breakdown, start, end}) => {
	let url = ServerIO.APIBASE+'/datafn/sum';
	const params = {
		data: {q, breakdown, start, end}
	};
	return ServerIO.load(url, params);
};

/**
 * The revenue for a publisher
 * @returns Promise {
 * 	by_vert: {String: Money}
 * 	total: {Money},
 * 	stats: {}
 * }
 */
ServerIO.getRevenueData = ({q, start, end}) => {
	let url = ServerIO.APIBASE+'/datafn/sum'; // FIXME DW to write the backend for this!
	const params = {
		data: {q, breakdown:"vert", start, end}
	};
	return ServerIO.load(url, params);
};

/**
 * @param vert {?String} Advert ID. If unset, sum all.
 * @returns Promise {
 * 	total: Number,
 * 	money: Money
 * }
 */
ServerIO.getAllSpend = ({vert}) => {
	let url = ServerIO.APIBASE+'/datafn/sum';
	const params = {
		data: {vert}
	};
	return ServerIO.load(url, params);
};

ServerIO.getDonationsCrm = ({start, end}) => {
	let url = ServerIO.PORTAL_ENDPOINT+'/datafn/crm';
	const params = {
		data: {start, end}
	};
	return ServerIO.load(url, params);
};

ServerIO.getOffset = () => {
	let url = ServerIO.APIBASE+'/datafn/offset';
	return ServerIO.load(url);
};